module.exports = function () {

	var $eSignCanvas = $('#eSign'),
			$eSignClearBtn = $('#eSignClearBtn');

	var DrawingController = new (require('./../../services/DrawingController'))($eSignCanvas, $eSignClearBtn);

	DrawingController.drawing();

	$('#submit-documentation').click(function (e) {

	//	var self = this;

		if(DrawingController.isCanvasBlank()){
			alert('You have to sign! The field is blank!');
			e.preventDefault();
		} else{
		//	alert('Is fine!');
			DrawingController.saveInInput();

			$('#submit-documentation').submit();
		}

	});

	$('#sumbit-property-proposal').click(function (e) {

        if(DrawingController.isCanvasBlank()){
            alert('You have to sign! The field is blank!');
            e.preventDefault();
        } else {
            DrawingController.saveInInput();

            $('#submit-documentation').submit();
		}
    });

    $('.submit-mir').click(function (e) {

        if(DrawingController.isCanvasBlank()){
            alert('You have to sign! The field is blank!');
            e.preventDefault();
        } else {
            DrawingController.saveInInput();

            $('.submit-mir').submit();
        }
    })

}();
